"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportNoData = exports.reportGraphQLErrors = exports.reportGraphQLError = exports.getErrorDisplayInfo = exports.getToastMessageForErrorCode = exports.getMessageForErrorCode = exports.isFatalError = exports.getGraphQLErrorCode = exports.getFirstGraphQLErrorCode = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var ErrorReporter_1 = require("../error/components/ErrorReporter");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
function getFirstGraphQLErrorCode(apolloError) {
    // TODO: Revisit the use of this cast when updating graphql/apollo dependencies (types) -- TFS 944332
    // The following dangerous cast SHOULD be safe so long as the locally GraphQLError type stays in sync
    // with the types of errors returned by the relationship service
    var graphQLErrors = apolloError.graphQLErrors;
    var firstError = graphQLErrors ? graphQLErrors[0] : null;
    return getGraphQLErrorCode(firstError);
}
exports.getFirstGraphQLErrorCode = getFirstGraphQLErrorCode;
function getGraphQLErrorCode(graphQLError) {
    return graphQLError && graphQLError.extensions ? graphQLError.extensions.code : null;
}
exports.getGraphQLErrorCode = getGraphQLErrorCode;
function isFatalError(errorCode) {
    return errorCode === 'INGESTION_FAILED' || errorCode === 'INTERNAL_SERVER_ERROR';
}
exports.isFatalError = isFatalError;
function getMessageForErrorCode(errorCode) {
    if (!errorCode) {
        return Localize_1.Messages.ErrorWithoutErrorCode();
    }
    switch (errorCode) {
        case 'BACKFILL_RUNNING':
            return Localize_1.Messages.ErrorBackfillRunning();
        case 'FEATURE_DISABLED':
            return Localize_1.Messages.ErrorFeatureDisabled();
        case 'INGESTION_FAILED':
            return Localize_1.Messages.ErrorIngestionFailed();
        case 'INTERNAL_SERVER_ERROR':
            return Localize_1.Messages.ErrorInternalServerError();
        case 'NODE_LIMIT_EXCEEDED':
            return Localize_1.Messages.ErrorNodeLimitExceeded();
        case 'PERMISSIONS_MODE_SWITCHED':
            // don't surface this error to the user, show a generic error
            return Localize_1.Messages.ErrorWithoutErrorCode();
        case 'RATE_EXCEEDED':
            return Localize_1.Messages.ErrorRateExceeded();
        case 'TIME_LIMIT_EXCEEDED':
            return Localize_1.Messages.ErrorTimeLimitExceeded();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(errorCode);
            return '';
    }
}
exports.getMessageForErrorCode = getMessageForErrorCode;
function getToastMessageForErrorCode(errorCode) {
    switch (errorCode) {
        case 'BACKFILL_RUNNING':
            return Localize_1.Messages.ErrorBackfillRunningToast();
        case 'FEATURE_DISABLED':
            return Localize_1.Messages.ErrorFeatureDisabled();
        case 'NODE_LIMIT_EXCEEDED':
            return Localize_1.Messages.ErrorNodeLimitExceededToast();
        case 'PERMISSIONS_MODE_SWITCHED':
            // in this case, used for logging
            return 'PERMISSIONS_MODE_SWITCHED error occured';
        case 'RATE_EXCEEDED':
            return Localize_1.Messages.ErrorRateExceededToast();
        case 'TIME_LIMIT_EXCEEDED':
            return Localize_1.Messages.ErrorTimeLimitExceededToast();
        default:
            return Localize_1.Messages.ErrorWithoutErrorCode();
    }
}
exports.getToastMessageForErrorCode = getToastMessageForErrorCode;
function getErrorDisplayInfo(errorCode) {
    var errorMessage = getToastMessageForErrorCode(errorCode);
    return {
        errorCode: errorCode || 'none',
        errorMessage: errorMessage,
    };
}
exports.getErrorDisplayInfo = getErrorDisplayInfo;
function reportGraphQLError(errorCode, key) {
    var displayInfo = getErrorDisplayInfo(errorCode);
    return (react_1.default.createElement(ErrorReporter_1.ErrorReporter, { key: key, errorCode: displayInfo.errorCode, errorMessage: displayInfo.errorMessage }));
}
exports.reportGraphQLError = reportGraphQLError;
// Note (drbr): Using the array index as key feels fishy. How can we be certain that the errors will always have the same index,
// even when moving from page to page? Is this "error component" pattern really the right one?
function reportGraphQLErrors(errors) {
    return errors.map(function (error, i) { return reportGraphQLError(getGraphQLErrorCode(error), "error_".concat(i)); });
}
exports.reportGraphQLErrors = reportGraphQLErrors;
function reportNoData() {
    return react_1.default.createElement(ErrorReporter_1.ErrorReporter, { errorCode: 'no_data', errorMessage: Localize_1.Messages.ErrorNoData() });
}
exports.reportNoData = reportNoData;
//# sourceMappingURL=GraphQLErrorFunctions.js.map